<template>
  <component
    :is="wrapperComponent"
    class="search-form"
    v-bind="wrapperAttrs"
    @submit.prevent="searchFunction"
  >
    <!-- @slot Can be used to provide a label if needed -->
    <slot />
    <div class="search-form__container">
      <button
        class="search-form__button search-form__button--left"
        data-test-id="search-form-button"
      >
        <span class="search-form__button-hidden-text">Search</span>
        <icon-component
          name="magnifying-glass"
          class="search-form__button-icon"
        />
      </button>
      <input
        :id="$attrs['id'] ? `${$attrs['id']}Input` : 'searchFormInput'"
        ref="searchFormInput"
        v-model="search"
        :name="$attrs['name'] || 'searchFormInput'"
        class="search-form__input"
        data-test-id="search-form-input"
        v-bind="$attrs"
        role="searchbox"
        type="text"
        @input="$emit('input', search)"
      >
      <button
        class="search-form__clear-button"
        data-test-id="search-form-clear-button"
        aria-label="Clear Search"
        :class="{ 'search-form__clear-button--active' : search.length > 0 }"
      >
        <icon-component
          v-if="search.length > 0"
          name="x"
          title="clear"
          class="search-form__clear-icon icon--smallest"
          @click="handleClearSearch"
        />
      </button>
      <button
        class="search-form__button search-form__button--right"
        data-test-id="search-form-button"
      >
        <span class="search-form__button-hidden-text">Search</span>
        <icon-component
          name="magnifying-glass"
          class="search-form__button-icon"
        />
      </button>
    </div>
  </component>
</template>

<script>
export default {
  name: 'SearchForm',
  props: {
    term: {
      type: String,
      default: '',
    },
    wrapperAttrs: {
      type: Object,
      default: () => {},
    },
    // This prop can be set to false if this component is nested in another form
    // which would not be valid HTML
    isForm: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    wrapperComponent() {
      return this.isForm ? 'form-component' : 'div';
    },
  },
  watch: {
    term(to) {
      this.search = to;
    },
  },
  created() {
    this.search = this.term;
  },
  methods: {
    searchFunction() {
      /**
       * Search event payload: term
       *
       * @type {string}
       */
      this.$emit('search', this.search);
    },
    handleClearSearch() {
      this.search = '';
      this.searchFunction();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_search-form';
</style>

<docs>

A generic search form that can be embedded in a page to add search functionality
within any context. The search event must be handled by the parent component
where the actual search logic will be executed.

</docs>
